/* 绑定
1.微信登录不返回用户信息("/wx/login")
2.引导用户绑定（注册接口）("/registerwithpwd")
3.注册成功后绑定账号("/wx/bindwx")


1.pc扫码或code
    https://open.weixin.qq.com/connect/qrconnect?appid=wx9d165c26bfc5a384
    &redirect_uri=http%3a%2f%2fyumsmartcity.com
    &response_type=code&scope=snsapi_login&state=sm#wechat_redirec

2.微信内获取
https://open.weixin.qq.com/connect/oauth2/authorize?
appid=wx39e84b0b854f1f0c
&redirect_uri=http%3A%2F%2Fwww.yunsmartcity.com%2Fsmartcity-web%2Fweb%2Fapi%2Fwx%2Fnotify
&response_type=code&scope=snsapi_userinfo&state=sm#wechat_redirec

*/


import config from '@/config/index';

// const config.BASE_API_PREFIX = '';
// const config.BASE_API_PREFIX = 'smartcity-web/web/api';

/**
 * 密码登入
 *
 * @param account
 * @param password
 * @return
 */
function loginApi() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/login`;
}

/*
获取验证码
mobile
 */
function queryVerifycode() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/verifycode`;
}

/**
 * 获取用户信息
 *
 * @param uid     用户id
 * @param request
 * @return
 */
function queryUserInfo() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/user`;
}

/**
 * 注册(密码)
 *
 * @param account         账号
 * @param password        密码
 * @param confirmpassword 确认密码
 * @param verifycode      验证码
 * @param request
 * @return
 */
function registerwithpwdApi() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/registerwithpwd`;
}

/**
 * 快速注册及验证码登入
 *
 * @param account    账号
 * @param verifycode 验证码
 * @param request
 * @return
 */
function registerApi() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/register`;
}
/**
 * 设置密码(带验证码)
 *
 * @param uid             用户ID
 * @param password        密码
 * @param confirmpassword 确认密码
 * @param verifycode      验证码
 * @param request
 * @return
 */
function setpasswordveriApi() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/setpasswordveri`;
}


/**
 * 获取微信授权token及用户openid(pc-web使用)
 *
 * @param code    前端授权码
 * @param request
 * @return
 */
function queryWxWebAccesstoken() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/wx/web/accesstoken`;
}

/**
 * 获取微信授权token及用户openid(微信内嵌H5使用)
 *
 * @param code    前端授权码
 * @param request
 * @return
 */
function queryWxH5Accesstoken() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/wx/h5/accesstoken`;
}

/**
 * 微信账号绑定
 *
 * @param account 账号
 * @param openid  微信openid
 * @param unionid  微信unionid
 * @param request
 * @return
 */
function wxBindwxApi() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/wx/bindwx`;
}

/**
 * 微信登录
 *
 * @param account 账号
 * @param openid  微信openid
 * @param unionid  微信unionid
 * @param request
 * @return
 */
function wxLoginApi() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/wx/login`;
}

/**
 * 设置密码(带验证码)
 *
 * @param account         账号
 * @param password        密码
 * @param confirmpassword 确认密码
 * @param verifycode      验证码
 * @param request
 * @return
 */

function setpasswordbyaccount() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/setpasswordbyaccount`;
}

/**
 * 修改用户基本信息
 *
 * @param uid             用户id
 * @param name            姓名
 * @param gender          性别
 * @param certificatetype 证件类型
 * @param idcard          证件号
 * @param email           邮箱
 * @param address         地址
 * @param headimg         头像
 * @param tag             标识
 * @param organization    结构名称
 * @param scc             社会信用代码
 * @param request
 * @return
 */
function modifyusrinfo() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyusrinfo`;
}

/**
 * 修改用户基本信息
 * @param token
 * @param @PostMapping("/logout")
 */
function logout(){
  return `${config.HOST_API}${config.BASE_API_PREFIX}/logout`;
}


export {
  loginApi,
  queryVerifycode,
  registerwithpwdApi,
  registerApi,
  setpasswordveriApi,
  queryWxWebAccesstoken,
  queryWxH5Accesstoken,
  wxBindwxApi,
  wxLoginApi,
  setpasswordbyaccount,
  modifyusrinfo,
  queryUserInfo,
  logout,
};
